import { Row } from 'antd';
import { STAFF_CALENDAR_PAGE_SIZE, STAFF_CALENDAR_PAGE_ZOOM_SIZE } from 'constants/calendar';
import { memo, useMemo } from 'react';
import { ANYONE } from './anyone';
import { getColorSet } from './helper';
import CalendarStyled, { fixedStyle, isModeFull } from './styles';
import { ICalendarHeader, ICalendarSchema } from './types';
type Props = {
  headers: ICalendarHeader<any>[];
  renderHeader: ICalendarSchema['renderHeader'];
  fullScreen?: boolean;
  enablePaging?: boolean;
};
const CalendarViewHeader = ({ headers = [], renderHeader = () => undefined, fullScreen = false, enablePaging }: Props) => {
  const itemWidthPercent = (100 / (fullScreen ? STAFF_CALENDAR_PAGE_ZOOM_SIZE : STAFF_CALENDAR_PAGE_SIZE));
  const paddingItems = useMemo(() => {
    if (!enablePaging) return null;
    const lengthItem = (fullScreen ? STAFF_CALENDAR_PAGE_ZOOM_SIZE : STAFF_CALENDAR_PAGE_SIZE) - (headers?.length || 0);
    if (!lengthItem || lengthItem < 0) return null;
    const arr = Array.from(Array(lengthItem).keys());
    return <>
      {arr.map((o) => (
        <CalendarStyled.TH
          key={o}
          fixed
          className='fixed-time-anyone'
          style={isModeFull.value ? {
            width: itemWidthPercent + '%',
            borderRight: '1px solid #fff'
          } : {
            borderRight: '1px solid #fff'
          }}
        >
          <div className='wrap zoom-control-header'>
          </div>
        </CalendarStyled.TH>
      ))}
    </>;
  }, [headers, fullScreen, enablePaging, itemWidthPercent]);

  return (
    <CalendarStyled.THead className='zoom-control-body'>
      <CalendarStyled.TRow>
        <CalendarStyled.TH className='fixed-time-td' fixedHigh style={fixedStyle}>
          <Row className='actions' justify={'space-between'} />
        </CalendarStyled.TH>
        {headers.length > 0 ? headers.map((item) => {
          const colorSet = getColorSet(item.typeColor);
          return (
            <CalendarStyled.TH
              key={item.id}
              fixed
              className='fixed-time-anyone'
              anyone={item.id === ANYONE.id}
              style={isModeFull.value ? {
                width: itemWidthPercent + '%',
              } : {}}
              colorSet={colorSet}
            >
              <div className='wrap zoom-control-header'>
                {renderHeader(item)}
              </div>
            </CalendarStyled.TH>
          );
        }) : <>
          <CalendarStyled.TH fixed />
        </>}
        {paddingItems}
      </CalendarStyled.TRow>
    </CalendarStyled.THead>
  );
};

export default memo(CalendarViewHeader);
